(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["01pro"] = factory();
	else
		root["01pro"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 